import React from 'react'
import { UserAuth } from '../../context/AuthContext'
import { GrVirtualMachine } from 'react-icons/gr';
import { HiOutlineBell } from 'react-icons/hi';

const Landing = () => {
  const { user } = UserAuth();

  const uname = user.displayName;
  return (
    <div className='pb-[96px]'>
      <div className='md:block hidden px-4 pt-4 pb-2'>
        <div className='border bg-white border-slate-200 rounded-md'>
          <div className='p-4'>
            <h1 className='text-2xl font-semibold'>
              Selamat datang 👋, {uname}</h1>
            <p className='pt-2 text-slate-700 md:text-base text-sm md:font-normal font-medium'>Baru bergabung IziUSE? Lihat panduan untuk memulai </p>
          </div>
          <div className="bottom-0 rounded-b-md bg-gradient-to-r from-primary to-blue-600 h-1"></div>
        </div>
      </div>
      <div className='px-4 pt-2 pb-4'>
        <div className='p-4 rounded-md bg-white border border-slate-200'>
          <div className='flex flex-row justify-between'>
            <div>
              <h2 className='text-base font-semibold'>
                Beranda
              </h2>
              <p className='pt-1 text-slate-700 text-sm'>Lihat kabar terbaru dari kami</p>
            </div>
            <div>
              <button className='rounded-md border border-primary text-primary px-2 py-1 text-sm font-medium'>Lihat Semua</button>
            </div>
          </div>
          <div className="grid grid-rows-2 gap-4 px-4 pb-2 pt-4">
            <div className='flex flex-row items-start'>
              <GrVirtualMachine className='mr-2' size='24px' />
              <div className=''>
                <p className='font-medium md:text-sm text-xs'>Pemberitahuan Sistem  </p>
                <p className='font-normal md:text-sm text-xs'> Lorem ipsum dolor sit amet, consectetur adipisicing elit.</p>
              </div>
            </div>
            <div className='flex flex-row items-start'>
              <HiOutlineBell className='mr-2' size='24px' />
              <div className=''>
                <p className='font-medium md:text-sm text-xs'>Notifikasi Pesan  </p>
                <p className='font-normal md:text-sm text-xs'> Lorem ipsum dolor sit amet, consectetur adipisicing elit.</p>
              </div>
            </div>
            <div className='rounded-md border py-2 px-4 border-yellow-500 bg-yellow-100 text-yellow-600 md:text-sm text-xs font-normal'>
              <span className='font-medium'>System: </span> Lorem ipsum dolor sit amet, consectetur adipisicing elit.
            </div>
            <div className='rounded-md border py-2 px-4 border-green-500 bg-green-100 text-green-600 md:text-sm text-xs'>
              <span className='font-medium'>Pesan: </span> Lorem ipsum dolor, sit amet consectetur adipisicing elit.
            </div>
          </div>
        </div>
      </div>
      <div className='hidden md:block p-4 bg-gradient-to-r from-indigo-50 to-cyan-50 text-primary font-normal text-sm'>
        <div className='flex flex-row justify-between relative'>
          <div className='-mr-[244px] leading-relaxed'>
            <p className='font-semibold text-xl mb-5'>Ajak temanmu bergabung IziUSE</p>
            Berikan kode <span className='font-semibold'>R-0521025151</span> ke temanmu
            <br />
            Atau invite melalui link berikut:
            <br /><span className='font-semibold'>https://izi.web.app/?r=xxxxx</span>
            <br />
            <br />
            <br />
            <span className="md:block hidden">*Bonus masa aktif premium setiap kali kamu menginvite temanmu!</span>

          </div>
          <div className='w-[244px]'>
            <img src="images/invite-teman.png" className='min-w-[244px]' alt="" />
          </div>
        </div>
      </div>
      <div className='md:hidden p-4 bg-cyan-50'>
        <div className='flex flex-row justify-between items-center'>
          <div className='leading-relaxed text-primary text-sm '>
            <p className=''>Ajak temanmu untuk</p>
            <p className=''>bergabung dengan IziUSE</p>
            <p className='font-medium '>*Dapatkan Bonus masa aktif premium</p>
          </div>
          <div className='w-[144px]'>
            <img src="images/invite-teman.png" className='min-w-[144px]' alt="" />
          </div>
        </div>
        <div className='grid grid-cols-2 gap-6 pt-4'>
          <div className='border border-gray-300 rounded-md text-primary font-medium'>
            <button className='w-full rounded-md p-1'>Kode Referal</button>
          </div>
          <div className='text-white font-medium rounded-md bg-primary'>
            <button className='w-full rounded-md p-1'>Invite Link</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Landing
